<template>
  <div class="dashboard-space dashboard-background min-vh-100">
    <!--    <alert-bar-->
    <!--      v-if="!isAws"-->
    <!--      @click="() => awsModal = true"-->
    <!--    />-->
    <dashboard-header />
    
    <!-- Topbar -->
    <dashboard-topbar :title="folder && !search ? folder.name : 'My Projects'">
      <div
        v-if="subscriptionIsActive"
        class="ml-auto flex items-center"
      >
        <create-folder-modal v-if="!search" />
        <b-btn
          class="d-flex align-items-center px-4 ml-3"
          variant="primary"
          @click="createNewProjectProcess"
        >
          Create New Project
          <svg
            class="ml-2"
            fill="none"
            height="12"
            viewBox="0 0 11 12"
            width="11"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M6.808 11.815H4.807V7.146H0.667V5.329H4.807V0.843999H6.808V5.329H10.925V7.146H6.808V11.815Z"
              fill="white"
            />
          </svg>
        </b-btn>
        <b-btn
          class="d-flex align-items-center px-4 ml-3"
          variant="primary"
          @click="browseTemplatesProcess"
        >
          Browse Templates
          <svg
            class="ml-2"
            fill="none"
            height="12"
            viewBox="0 0 11 12"
            width="11"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M6.808 11.815H4.807V7.146H0.667V5.329H4.807V0.843999H6.808V5.329H10.925V7.146H6.808V11.815Z"
              fill="white"
            />
          </svg>
        </b-btn>
      </div>
    </dashboard-topbar>
    <!-- End Topbar -->

    <div class="dashboard-container">
      <!-- Dashbaord Controls Bar -->
      <dashboard-header-controls />
      <!-- End Dashbaord Controls Bar -->

      <div
        v-if="loading"
        class="d-flex align-items-center justify-content-center min-vh-50"
      >
        <b-spinner variant="primary" />
      </div>

      <template v-else>
        <!-- Folders -->
        <dashboard-fodlers :show-folders="subscriptionIsActive" />
        <!-- End Folders -->

        <div
          v-if="loadingMoreProjects"
          class="text-center py-5"
        >
          <b-spinner variant="primary" />
        </div>
      </template>
    </div>

    <RestoreProjectsModal
      :value="restoreProjectModal"
      @close="restoreProjectModal = false"
    />
    <last-changes-modal />
  </div>
</template>

<script>
import {mapGetters, mapState} from 'vuex'
// import AlertBar from '@/components/alert-bar/AlertBar.vue'
import DashboardHeader from '../../layouts/dashboard/DashboardHeader'
import DashboardTopbar from '../../layouts/dashboard/DashboardTopbar'
import DashboardHeaderControls from '../../layouts/dashboard/compontens/topbar/DashboardHeaderControls'
import DashboardFodlers from '../../layouts/dashboard/compontens/folders/DashboardFodlers'
import CreateFolderModal from '../../layouts/dashboard/compontens/templates/CreateFolderModal'
import Cookie from '../../components/mixins/Cookie'
import RouterMixin from '../../components/mixins/RouterMixin'
import LastChangesModal from '@/components/builder/LastChangesModal.vue'
import RestoreProjectsModal from '@/components/builder/RestoreProjectsModal.vue'

export default {
  name: 'Dashboard',
  components: {
    // AlertBar,
    RestoreProjectsModal,
    LastChangesModal,
    CreateFolderModal,
    DashboardFodlers,
    DashboardHeaderControls,
    DashboardTopbar,
    DashboardHeader
  },
  mixins: [Cookie, RouterMixin],
  data () {
    return {
      awsModal: false,
      restoreProjectModal: false
    }
  },
  computed: {
    ...mapState('dashboard', {
      folder: state => state.folder,
      loading: state => state.loading,
      loadingMoreProjects: state => state.loadingMoreProjects,
      search: state => state.search
    }),
    ...mapState('auth', {
      user: state => state.user
    }),
    ...mapGetters('auth', {
      subscriptionIsActive: 'subscriptionIsActive'
    }),
    // canCreateProjects () {
    //   return this.user.user_subscription?.plan?.projects_count >= this.user.projects_count
    // },
    limitExceeded () {
      // return !!this.user.user_subscription?.plan?.projects_count && this.user.user_subscription?.plan?.projects_count < this.user.projects_count
      return ['STARTER', 'STARTER_Y'].includes(this.user.user_subscription?.plan?.code) && this.user.projects_count > 1
    }
  },
  async created () {
    await this.checkIntegrationRedirect()
    await this.$store.dispatch('dashboard/getDashboardData')
    if (this.limitExceeded) {
      this.restoreProjectModal = true
    }
  },
  mounted () {
    this.$store.commit('projects/RESET')
    this.$store.state.pages.page = {}
    this.$store.dispatch('sections/setSections', [])
    document.addEventListener('scroll', this.loadMoreProjects)
  },
  destroyed () {
    document.removeEventListener('scroll', this.loadMoreProjects)
  },
  methods: {
    createNewProjectProcess () {
      this.$router.push('/templates?new_project=1')
    },
    browseTemplatesProcess () {
      this.$router.push('/templates')
    },
    loadMoreProjects () {
      if ((window.innerHeight + window.pageYOffset) >= document.body.offsetHeight) {
        this.$store.dispatch('dashboard/loadProjects')
      }
    },
    async checkIntegrationRedirect () {
      if (this.$route.query.code && this.get_cookie('mailServiceAPI')) {
        const integration = this.get_cookie('mailServiceAPI').split(',')
        console.log(this.get_cookie('mailServiceAPI'))

        await axios.get(
          `api/projects/${integration[0]}/auto-responders/${integration[1]}/token`, 
          {
            params: {
              code: this.$route.query.code,
              location: this.$route.query.location,
              state: this.$route.query.state
            }
          }
        )
          .then(() => {
            this.delete_cookie('mailServiceAPI')

            this.$swal({
              icon: 'success',
              title: 'Mail service integrated!',
              text: 'Redirecting to the editor...',
              showConfirmButton: false,
              timer: 1500,
              willClose: () => {
                window.close()
              }
            })
          })
      }
    }
  }
}
</script>

<style lang="scss">
.dashboard-background {
  background-color: #F7F8F9;
  padding-top: 0px;
}
</style>
